import { render, staticRenderFns } from "./ShareProductModal.vue?vue&type=template&id=005488a0&scoped=true&"
import script from "./ShareProductModal.vue?vue&type=script&lang=js&"
export * from "./ShareProductModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareProductModal.vue?vue&type=style&index=0&id=005488a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005488a0",
  null
  
)

export default component.exports